const LEGACY_AWS_SOURCE = 'https://s3-us-west-2.amazonaws.com/dutchie-images/';
const NEWER_AWS_SOURCE = 'https://dutchie-images.s3.us-west-2.amazonaws.com/';
const IMGIX_SOURCE = 'https://images.dutchie.com/';

export const ensureSecureUrlProtocol = (src: string | null | undefined): string | null | undefined => {
  if (!src) {
    return src;
  }
  return src.replace('http://', 'https://');
};

export const replaceAWSSourceWithImgix = (src: string | null | undefined): string => {
  src = (ensureSecureUrlProtocol(src) ?? '').trim();
  // Replace legacy S3 format with imgix
  if (src.includes(LEGACY_AWS_SOURCE)) {
    src = src.replace(LEGACY_AWS_SOURCE, IMGIX_SOURCE);
  }
  // Replace newer S3 format with imgix
  else if (src.includes(NEWER_AWS_SOURCE)) {
    src = src.replace(NEWER_AWS_SOURCE, IMGIX_SOURCE);
  }
  return src;
};

export const replaceAllAWSSourceWithImgix = (src: string | null | undefined): string => {
  src = (src ?? '').trim();
  // Replace all occurrences globally, including http versions
  src = src.replace(new RegExp(LEGACY_AWS_SOURCE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), IMGIX_SOURCE);
  src = src.replace(new RegExp(NEWER_AWS_SOURCE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), IMGIX_SOURCE);
  src = src.replace(
    new RegExp(LEGACY_AWS_SOURCE.replace('https://', 'http://').replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'),
    IMGIX_SOURCE
  );
  src = src.replace(
    new RegExp(NEWER_AWS_SOURCE.replace('https://', 'http://').replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'),
    IMGIX_SOURCE
  );
  return src;
};
